import ENV from "@/engine/env/web.env";

export default function getBaseURL(endpoint: string): string {
  return `${ENV.api.version}/${endpoint}`;
}
